<div class="search-o mutual-opacity" (click)="showOverlay()">
  <i class="icon-search"></i>
  <span>{{ 'sear_g' | translate }}</span>
</div>

<ng-template #overlayTemplate>
  <div class="page-container search-main">
    <div class="main-container">
      <div class="container">
        <div class="content-box" @enter>
          <div #contentEl appLifeObserve (lifeChange)="initBreakpoint($event, contentEl)">
            <app-customize-input
              width="100%"
              size="large-medium"
              [autoFocus]="true"
              [fixedHeight]="true"
              [placeholder]="'sear_g' | translate"
              [leftIcon]="'icon-search'"
              [onChangeDebounceTime]="0"
              (onChange)="searchValueChange()"
              [(value)]="searchValue"
              [trim]="false"
            >
              <span right-content class="cancel-btn mutual-opacity" (click)="close()">{{ 'cancels' | translate }}</span>
            </app-customize-input>

            <div class="tip-text" *ngIf="!realSearchValue">{{ 'least_three' | translate }}</div>

            <!-- 有内容，分别为标签类型 和 游戏类型 -->
            <div class="result" *ngIf="realSearchValue" [appLoading]="loading" [class.minh]="!searchResult || loading">
              <ng-container *ngIf="searchResult && !loading">
                <div class="result-tit">
                  <span>{{ 'sear_res' | translate }}</span>
                  <em>{{ 'ser_result_leng_t' | translate: resultLength }}</em>
                </div>
                <div class="result-con" #resultEl>
                  <app-scrollbar scrollbarRight="-6px" thumbOpacity="0.3">
                    <div class="labels" *ngIf="searchResult.labelInfo.length > 0">
                      <a
                        *ngFor="let item of searchResult.labelInfo"
                        [href]="domain + '/' + appService.languageCode + '/casino/category' + item.labelId"
                        (click)="clicklabelItem(item.labelId); $event.preventDefault()"
                      >
                        <span class="mutual-opacity">
                          {{ item.labelName }}
                        </span>
                      </a>
                    </div>
                    <div
                      class="games"
                      *ngIf="searchResult.gameInfo.length > 0"
                      style.grid-template-columns="repeat({{ breakpoint }},1fr)"
                    >
                      <app-game-unit
                        *ngFor="let item of searchResult.gameInfo"
                        (afterClickItem)="close()"
                        [item]="item"
                      ></app-game-unit>
                    </div>
                  </app-scrollbar>
                </div>
              </ng-container>
              <!-- 空内容，搜索栏有内容，无结果，且非加载中的时候显示 -->
              <app-empty
                *ngIf="!searchResult && !loading"
                iconWidth="auto"
                [icon]="'assets/temp5/search-no-data.svg'"
                [text]="'no_data' | translate"
              ></app-empty>
            </div>

            <!-- 历史搜索的词：搜索栏未填写内容时候显示 -->
            <div class="history" *ngIf="!realSearchValue && searchHistory.length > 0">
              <div class="history-tit">
                <span>{{ 'rec_sear' | translate }}</span>
                <i class="icon-trash-can mutual-opacity" (click)="clearHistory()"></i>
              </div>
              <div class="history-con">
                <span
                  *ngFor="let item of searchHistory; let i = index"
                  (click)="searchValue = item; searchValueChange()"
                >
                  <em>{{ item }}</em>
                  <i class="icon-error" (click)="$event.stopPropagation(); updateSearchHistory(undefined, i)"></i>
                </span>
              </div>
            </div>

            <app-new-swiper-unit
              class="recommend-games"
              [title]="recommenGames?.labelName"
              [gameData]="recommenGames?.gameLists"
              (afterClickItem)="close()"
            ></app-new-swiper-unit>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
